import { Component, Injector, ViewEncapsulation, OnInit, ViewChild, Input, Renderer2, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { GridComponent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app-core/services/common.service';
import { ServicesApiService } from 'src/app/services/services-api.service';
import { CommonDataModel } from '../common-data-model';
import * as _ from 'lodash';
const hasClass = (el, className) => new RegExp(className).test(el.className);
const isChildOf = (el, className) => {
  while (el && el.parentElement) {
    if (hasClass(el.parentElement, className)) {
      return true;
    }
    el = el.parentElement;
  }
  return false;
};

@Component({
  selector: 'app-orders-shipping-unit-list',
  templateUrl: './orders-shipping-unit-list.component.html',
  styleUrls: ['./orders-shipping-unit-list.component.scss']
})
export class OrdersShippingUnitListComponent implements OnInit {

  @ViewChild('grid', { static: true }) private grid: GridComponent;
  @ViewChild('shippingUnitsForm', { static: true }) shippingUnitsForm: NgForm;
  @Output() emitServices: EventEmitter<any> = new EventEmitter<any>();
  @Input() accountId: any;
  commmonDataModel = new CommonDataModel();
  editedRowIndex: number;
  gridItems: any = {
    data: [],
    total: 0
  };
  isGridDataValid = true;
  constructor(private servicesApiService: ServicesApiService,
              private commonService: CommonService,
              private toastr: ToastrService,
              private dialog: MatDialog,
              private renderer: Renderer2) {
    this.renderer.listen(
      'document',
      'click',
      ({ target }) => {
        if (!isChildOf(target, 'shippingUnitsGrid')) {
          if (this.shippingUnitsForm.valid) {
            this.isGridDataValid = true;
          } else {
            this.isGridDataValid = false;
          }
          this.grid.closeRow(this.editedRowIndex);
          this.editedRowIndex = null;
        }
      });
  }

  ngOnInit() {
  }

  onAddNewShippingUnit(): void {
    this.gridItems.data.splice(0, 0, this.generateNewRow());
    // this.shippingUnitsForm.form.markAsDirty();
  }

  onCellClickHandler({ sender, rowIndex, columnIndex, dataItem, isEdited }, grid: any) {
    if (this.shippingUnitsForm.valid) {
      this.isGridDataValid = true;
    } else {
      this.isGridDataValid = false;
    }
    grid.closeRow(this.editedRowIndex);
    this.editedRowIndex = rowIndex;
    sender.editRow(rowIndex);
  }

  onServiceDelete(rowIndex: number, shippingUnit: any) {
    this.commonService.getConfirmationPopup(`You want to remove this shipping uint ?`).then(result => {
      if (result) {
        this.editedRowIndex = null;
        this.gridItems.data.splice(rowIndex, 1);
        // this.shippingUnitsForm.form.markAsDirty();
      }
    });
  }

  generateNewRow(): any {
    return Object.assign({}, _.cloneDeep(this.commmonDataModel.shippingUnitObject));
  }

}
